/** Last-visit hint so the home page can paint a full-size Mitti card immediately. */
export const HAS_MITTI_KEY = 'akhara.hasMitti';

/**
 * True unless this browser last saw no Mitti (`0`).
 * Missing or unreadable storage shows the full placeholder so a Mitti is not missed.
 */
export function readHadMitti(): boolean {
  try {
    return localStorage.getItem(HAS_MITTI_KEY) !== '0';
  } catch {
    return true;
  }
}

export function writeHadMitti(had: boolean): void {
  try {
    localStorage.setItem(HAS_MITTI_KEY, had ? '1' : '0');
  } catch {
    /* private mode / quota */
  }
}
